import React, { useEffect, useState } from 'react'
import { postInformacionEmpresa, postObtenerTodosLosConsentimientosInformadosDeUnUsuarioConTag } from '../../services/PaginaRuta'
import { Document, Page, Image, PDFDownloadLink, Text } from '@react-pdf/renderer';

const ModalConfirmarDescargaPDFConsentimientoInformado = ({setdescargarPDFConsentimientoInformado,dataUnConsentimientoInformado}) => {
    // const [dataPDFConsentimientoInformado, setdataPDFConsentimientoInformado]=useState({
    //     "codigo_consentimiento":'',
    //     "documento":'',
    //     "fecha":'',
    //     "firma":'',
    //     "id":'',
    //     "tag":'',
    //     "tpdocumento":''
    // })
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [informacionEmpresa, setinformacionEmpresa]=useState({
        EmpRazSoc:'',
        EmpNit:''
      })
    const [dataPDFConsentimientoInformado, setdataPDFConsentimientoInformado]=useState([])
    const [loading, setloading]=useState(true)

    const handleCancelarClick=()=>{
        setdescargarPDFConsentimientoInformado(false) 
    }

    useEffect(()=>{
        const userConsentimientos={
            "consentimiento":dataUnConsentimientoInformado.codigo_consentimiento,
            "tpdocumento":dataUnConsentimientoInformado.tipo_documento,
            "documento":dataUnConsentimientoInformado.numero_documento,
            "ProCirCod": dataUnConsentimientoInformado.ProCirCod,
            "idTbConsentimiento":dataUnConsentimientoInformado.id
        }
        setloading(false)
        postObtenerTodosLosConsentimientosInformadosDeUnUsuarioConTag(userConsentimientos).then((res)=>{
          setloading(true)
            if(res.data.data){
                setdataPDFConsentimientoInformado(res.data.data)
            }
            
        })
    },[])

    useEffect(()=>{
        const datosEmpresa={
          "EMPCOD":usuarioInfo.Empresa ,
          "MCDpto":usuarioInfo.Sede
      }
      postInformacionEmpresa(datosEmpresa).then((res)=>{
        setinformacionEmpresa(res.data[0]) 
      })
      
      },[])

    
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#437cdc]">
          <h5
            className="text-xl font-medium leading-normal text-white"
            id="exampleModalScrollableLabel"
          >
            Descargar PDF
          </h5>
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative p-4">
          <div className="flex py-2 text-left">
            <div className="w-3/3  px-4">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                Esta seguro de Descargar el PDF?
              </label>
            </div>
          </div>
        </div>
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            No
          </button>
          <PDFDownloadLink document={<MyDocument informacionEmpresa={informacionEmpresa} dataPDFConsentimientoInformado={dataPDFConsentimientoInformado} dataUnConsentimientoInformado={dataUnConsentimientoInformado}/> } fileName="consentimiento_informado_firmadoo.pdf">
          <button
            type="button"
            //onClick={handleOnclickPreparado}
            className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
          >
            Si
          </button> 
          </PDFDownloadLink>
        </div>
      </div>
    </div>
    {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }
  </div>
  )
}

export default ModalConfirmarDescargaPDFConsentimientoInformado

// Componente para generar el PDF con la firma
const MyDocument = ({ signature, informacion, informacionEmpresa, titulo,dataPDFConsentimientoInformado, dataUnConsentimientoInformado}) => {
    
    return (
    <Document>
        <Page size='A4' style={{padding: '50px' }}>
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{informacionEmpresa.EmpRazSoc}</Text>            
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{informacionEmpresa.EmpNit}</Text>
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{dataUnConsentimientoInformado.nombre_consentimiento}</Text>                        
            <Text style={{marginTop: 2, borderTop: '1pt solid #000', marginTop: 4, padding: '5px'}}/>            
            {processContent(dataUnConsentimientoInformado.texto, dataPDFConsentimientoInformado)}            
        </Page>      
    </Document>
  );
}

const processContent = (text, images) => {
  // Dividir el texto por líneas para mantener el formato
  const lines = text.split('\n');

  return lines.map((line, index) => {
    let elements = [line];

    // Iteramos sobre cada imagen y su tag
    images.forEach(image => {
      // Para cada elemento, si es string y contiene el tag, hacemos el reemplazo
      elements = elements.flatMap((el, i) => {
        if (typeof el !== 'string' || !el.includes(image.tag)) {
          return [el];
        }

        const parts = el.split(image.tag);
        return parts.reduce((acc, part, idx) => {
          if (idx < parts.length - 1) {
            return [
              ...acc,
              part,
              <Image
                src={image.firma}
                key={`${image.tag}-${i}-${idx}`}
                style={{ width: 100, height: 50 }}
              />
            ];
          }
          return [...acc, part];
        }, []);
      });
    });

    return (
      <Text key={index} style={{ fontSize: 9, padding: '5px' }}>
        {elements}
      </Text>
    );
  });
};


// const processContent = (text, images) => {
//   // Dividir el texto por líneas para mantener el formato
//   const lines = text.split('\n');

//   // Procesar cada línea
//   return lines.map((line, index) => {
//     let elements = [line];

//     images.forEach(image => {
//       if (line.includes(image.tag)) {
//         const parts = line.split(image.tag);

//         elements = parts.reduce((acc, part, idx) => {
//           if (idx < parts.length - 1) {
//             return acc.concat(
//               part,
//               <Image
//                 src={image.firma}
//                 key={`${image.tag}-${idx}`}
//                 style={{ width: 100, height: 50 }}
//               />
//             );
//           } else {
//             return acc.concat(part);
//           }
//         }, []);
//       }
//     });

//     return (
//       <Text key={index} style={{fontSize: 9, padding: '5px' }}>
//         {elements}
//       </Text>
//     );
//   });
// };